import React from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { MoreResults } from './components/MoreResults';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SocialProof } from './components/SocialProof';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { Testimonials } from './components/Testimonials';
import { UrgencySection } from './components/UrgencySection';
export function App() {
  return <div className="min-h-screen w-full overflow-hidden bg-stage text-ink" data-id="element-0" data-mp="3ii4s22026sok">
      <MetaPixel data-id="element-1" data-mp="3mjq1tehaqquj" />
      <main data-id="element-2" data-mp="3mj6ipufwtwex">
        <Hero data-id="element-3" data-mp="3rc9ca2kot5v4" />
        <SocialProof data-id="element-4" data-mp="3rbrakqf99zft" />
        <Testimonials data-id="element-5" data-mp="3rdarmj8qkein" />
        <ProblemSection data-id="element-6" data-mp="3rd1all5o5hp3" />
        <SystemSection data-id="element-7" data-mp="3relwkmdx3sbc" />
        <ModulesSection data-id="element-8" data-mp="6hovayao7c0" />
        <BonusSection data-id="element-9" data-mp="4n53zyrel9i" />
        <UrgencySection data-id="element-10" data-mp="56lhc8rh1lf" />
        <PricingSection data-id="element-11" data-mp="2zl3bdjx5744s" />
        <MoreResults data-id="element-12" data-mp="2zlv66six0xu0" />
        <GuaranteeSection data-id="element-13" data-mp="2zmenq84nlk7i" />
        <FAQ data-id="element-14" data-mp="2zn6biws0edn8" />
        <ClosingSection data-id="element-15" data-mp="33mouhn09senf" />
        <SummaryTable data-id="element-16" data-mp="33m5bs42spm8c" />
        <FinalCta data-id="element-17" data-mp="33ngdzzglelxc" />
      </main>
      <Footer data-id="element-18" data-mp="33orjc3pos1qk" />
      <PurchaseNotification data-id="element-19" data-mp="38lrnua6w0wfk" />
    </div>;
}